import React from "react";

class NotMatch extends React.Component {
  render() {
    return <div style={{ color: "white" }}>404 Page!</div>;
  }
}

export default NotMatch;
